// Analytics
export const ANALYTICS_LABEL = 'Cards Vertical Scroll Module';

// Desktop constants
// Controls scroll distance per card (in viewport height units)
export const DESKTOP_SCROLL_HEIGHT_PER_CARD_VH = 60;
